export class IdentificationTypeConstants {
  public static OFFLINE: string = 'OFFLINE';
  public static WEBID: string = 'WEBID';
  public static LIVEID: string = 'LIVEID';
}
